<ng-container *ngIf="screenType$ | async as screenType">
  <ng-container *ngIf="headerTemplate">
    <ng-container *ngTemplateOutlet="headerTemplate; context: {
      toggleSidebar,
      toggleSidebarRight,
      screenType
    }"></ng-container>
  </ng-container>
  <mat-drawer-container autosize>
    <mat-drawer
      #drawer
      *ngIf="sidebarTemplate"
      opened
      [mode]="withSidebarOver.includes(screenType) ? 'over' : 'side'">
      <ng-container *ngTemplateOutlet="sidebarTemplate; context: {
          toggleSidebar,
          screenType
        }">
      </ng-container>
    </mat-drawer>

    <mat-drawer
      #rightDrawer
      position="end"
      mode="over">
      <ng-container *ngIf="rightSidebarTemplate">
        <ng-container *ngTemplateOutlet="rightSidebarTemplate; context: {
          toggleSidebarRight,
        }"></ng-container>
      </ng-container>
    </mat-drawer>

    <!-- Padding bottom is necessary to avoid the footer on mobile devices overlapping the content -->
    <mat-drawer-content class="fx-col fx-g-1 fx-b-0 pb-20">
      <ng-container *ngIf="mainHeaderTemplate">
        <ng-container *ngTemplateOutlet="mainHeaderTemplate; context: {
          screenType
        }"></ng-container>
      </ng-container>
      <div class="customer-container fx-g-1 fx-col">
        <ng-container *ngIf="mainTemplate">
          <ng-container *ngTemplateOutlet="mainTemplate"></ng-container>
        </ng-container>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</ng-container>
